// extracted by mini-css-extract-plugin
export default {"root":"EfnJL8","content":"YsdzJE"};